import { render, staticRenderFns } from "./ProjectResourceSavingsPage.vue?vue&type=template&id=41e1f11d&scoped=true"
import script from "./ProjectResourceSavingsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectResourceSavingsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectResourceSavingsPage.vue?vue&type=style&index=0&id=41e1f11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1f11d",
  null
  
)

export default component.exports